/*!

=========================================================
* Paper Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import { withAuthentication } from '../components/Session';

import AdminNavbar from "../components/Navbars/AdminNavbar.jsx";
import Footer from "../components/Footer/Footer.jsx";
import Sidebar from "../components/Sidebar/Sidebar.jsx";
// import FixedPlugin from "components/FixedPlugin/FixedPlugin.jsx";
import { withFirebase } from "../components/Fb/context.js";
import { Container } from 'reactstrap'
import Alert from '../components/Alerts/FalconAlert'

import getProfileRoutes from "../routes.js";
import subroutes from "../subroutes.js";

const CURRENT_VERSION = '1.4.1'

var ps;

class CashierLayout extends React.Component {
  constructor(props) {
    super(props);
    this.mainPanel = React.createRef()
    this.state = {
      backgroundColor: "black",
      activeColor: "info",
      sidebarMini: false, 
      routes: getProfileRoutes(this.props.profile.role),
      news: []
    };
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.mainPanel.current);
    }
    // console.log('checking version 1')
    this.props.firebase.listenUiVersionVenue('prod').on('value', (snapshot) => {
      // console.log('checking version 2')
      // console.log(snapshot.exists())
      if (snapshot && snapshot.exists()) {
        if (snapshot.val().version !== CURRENT_VERSION) {
          this.setState({ uiversionAlert: <Container fluid={this.props.fluid ? true : false}><Alert color="danger" style={{ marginTop: 80 }}>Uusi versio {CURRENT_VERSION} julkaistu. Päivitä sulkemalla sivu ja avaamalle se uudelleen. Jos sulkeminen ei auta, niin paina Vaihto-näppäin pohjassa sivun uudelleenlatausta.</Alert></Container> })
        }
        if (snapshot.val().news) {
          const news = Object.keys(snapshot.val().news).map((x) => snapshot.val().news[x])
          console.log('setting news', news)
          this.setState({ news })
        }
        if(snapshot.val().videohelp) {
          const videohelp = snapshot.val().videohelp
          this.setState({ videohelp })
        }
      }
    })

    this.props.firebase.getCustomerRef().get().then((customer) => {
      if (customer.exists) {
        const _dn = customer.data().displayName ? customer.data().displayName : customer.data().name ? customer.data().name : ''
        if (_dn) {
          this.setState({ displayName: _dn })
        }
      } else {
        this.setState({ displayName: '' })
      }
    }
    )
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(prevProps) {
    // Only on an actual route change. This used to fire on EVERY update despite the comment,
    // so any re-render sent the page back to the top - the same bug that was fixed in
    // AdminLayout, and the reason a long list lost its place when a view inside it changed.
    const from = prevProps.location && prevProps.location.pathname
    const to = this.props.location && this.props.location.pathname
    if (from === to) return
    if (this.mainPanel.current) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.mainPanel.current.scrollTop = 0;
    }
  }

  getCompProps = (type, properties) => {
    var Type = type
    return <Type {...properties} />;
  }

  getComp = (type) => {
    var Type = type
    return <Type />;
  }

  getSubRoutes = subroutes => {
    return subroutes.map((prop, key) => {
      const RouteComponent = prop.component
      return (
        <Route
          path={prop.layout + prop.path}
          element={<RouteComponent {...this.props} />}
          key={key}
        />
      )
    })
  }

  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/cashier" || prop.layout === "/partner" || prop.layout === "/cooperative") {
        const RouteComponent = prop.component
        return (
          <Route
            path={prop.layout + prop.path}
            element={<RouteComponent {...this.props} {...prop.properties} />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  handleActiveClick = color => {
    this.setState({ activeColor: color });
  };
  handleBgClick = color => {
    this.setState({ backgroundColor: color });
  };
  handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false });
    } else {
      this.setState({ sidebarMini: true });
    }
    document.body.classList.toggle("sidebar-mini");
  }
  updateLastread = () => {
    this.props.firebase.updateLastread()
  }
  render() {
    console.log('CashierLayout', this.props)
    const profileRoutes = this.state.routes
    if(profileRoutes) {
      // console.log(profileRoutes)
    return (
      <div className="wrapper">
        <Sidebar
          {...this.props}
          routes={profileRoutes}
          bgColor={this.state.backgroundColor}
          activeColor={this.state.activeColor}
          displayName={this.state.displayName}
        />
        <div className="main-panel" ref={this.mainPanel} id="mainPanel">
          <AdminNavbar {...this.props} routes={profileRoutes} handleMiniClick={this.handleMiniClick} news={this.state.news} lastread={this.state.lastread} updateLastread={this.updateLastread} videohelp={this.state.videohelp} />
          {this.state.uiversionAlert}
          <Routes>
            {this.getRoutes(profileRoutes)}
            {this.getSubRoutes(subroutes)}
            {!this.props.user && <Route path="*" element={<Navigate to='/auth/login' replace />} />}
            <Route path="/" element={<Navigate to="/cashier/calendar" replace />} />
          </Routes>
          <CashierLayoutFooter />
        </div>
      </div>
    );
  }
  else {
    return (<></>)
  }
  }
}

// CashierLayout is a class component, so the route has to be handed to it as a prop for
// componentDidUpdate to tell navigation apart from an ordinary re-render.
function withLocation(Component) {
  return function WithLocation(props) {
    const location = useLocation()
    return <Component {...props} location={location} />
  }
}

// Wrapper component to access location in functional style
function CashierLayoutFooter() {
  const location = useLocation()
  if (location.pathname.indexOf("full-screen-map") !== -1) {
    return null
  }
  return <Footer fluid version={CURRENT_VERSION}/>
}

export default withFirebase(withLocation(CashierLayout));
